<template>
  <div>
    <div class="wrapper wrapper-full-page">
      <div class="full-page" :class="pageClass">
        <img
          src="/static/Oppo_LogoFinal-02.png"
          alt="Description of the image"
        />
        <div class="content">
          <div class="container">
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    pageClass: {
      type: String,
      default: "login-page",
    },
    backgroundColor: {
      type: String,
    },
  },
  data() {
    return {
      showMenu: false,
    };
  },
  methods: {
    closeMenu() {
      document.body.classList.remove("nav-open");
      document.body.classList.remove("off-canvas-sidebar");
    },
  },
  beforeDestroy() {
    this.closeMenu();
  },
};
</script>
<style scoped>
.navbar-nav .nav-item p {
  line-height: inherit;
  margin-left: 5px;
}

.full-page {
  background: linear-gradient(
    to bottom left,
    rgba(37, 55, 65, 1),
    rgba(37, 55, 65, 1),
    rgba(64, 78, 89, 1),
    rgba(92, 108, 118, 1),
    rgba(149, 162, 169, 1)
  );
}

img {
  margin-top: 30px;
  margin-left: 30px;
  height: 120px;
  padding: 10px;
}
</style>
